import { now } from "@@/shared/date-time/date-time";
import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { contactInfoZodObject } from "@@/shared/locations/contact-info";
import { orderIdZodSchema } from "@@/shared/orders/order-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const orderEditContactInfoCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("ORDER_EDIT_CONTACT_INFO_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    orderId: orderIdZodSchema,
    contactInfo: contactInfoZodObject,
    reason: z.string().optional(),
});

type OrderEditContactInfoCommand = z.infer<
    typeof orderEditContactInfoCommandZodObject
>;

const orderEditContactInfoCommandFactoryParamsZodObject =
    orderEditContactInfoCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });

type FactoryParams = z.infer<
    typeof orderEditContactInfoCommandFactoryParamsZodObject
>;

const orderEditContactInfoCommandFactory = (
    params: FactoryParams,
): OrderEditContactInfoCommand => {
    const command: OrderEditContactInfoCommand = {
        ...params,
        _id: generateId(),
        _type: "ORDER_EDIT_CONTACT_INFO_COMMAND" as const,
        _createdAt: now(),
    };
    return command;
};

export {
    orderEditContactInfoCommandFactory,
    orderEditContactInfoCommandFactoryParamsZodObject,
    orderEditContactInfoCommandZodObject,
};
export type {
    OrderEditContactInfoCommand,
    FactoryParams as OrderEditContactInfoCommandFactoryParams,
};
